import HeroBg from "public/cloudSecuritySase/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Secure Your Cloud Now ",
    link: "contact-us",
  },
  title: " Cloud Security Posture Management – Stay Secure, Stay Compliant ",
  desc: " Misconfigurations remain the #1 cloud security risk. OneMind’s CSPM offering ensures continuous visibility, policy enforcement, and automated remediation across AWS, Azure, and GCP. ",
  image: HeroBg,
};
